module.exports = __webpack_public_path__ + "img/emun_black_white.1df08bfc.svg";